export const textWithLink = (text: string | null) => {
  if (!text) {
    return text;
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.split(urlRegex).map((part, index) => {
    if (urlRegex.test(part) && index < 2) {
      return (
        <a
          className="mx-1 rounded-md border bg-bg-primary px-2 py-[1px] font-normal text-brand-secondary text-sm no-underline md:py-1"
          key={`${part}-${
            // biome-ignore lint/suspicious/noArrayIndexKey: skip
            index
          }`}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part.split('/').slice(0, 3).join('/')}
        </a>
      );
    }
    return part;
  });
};
